// extracted by mini-css-extract-plugin
export default {"link":"src-modules-membership-membership-expired-style__link_N9R17"};